// extracted by mini-css-extract-plugin
export default {"filter":"TextFilterHolder_filter__1kN-G"};